import { LogRequest, LogRequestToJSON } from '@/api/models'
import * as runtime from '../runtime'

export class LogApi extends runtime.BaseAPI {
  log(request: LogRequest) {
    const bodyParameters: runtime.HTTPBody = LogRequestToJSON(request)
    this.requestPost(`/log`, bodyParameters).then()
  }
}
